// extracted by mini-css-extract-plugin
export var chartRow = "bR_fT";
export var chartSection = "bR_fV";
export var dtiBlock = "bR_gY";
export var legendSection = "bR_fW";
export var priceBlock = "bR_gV";
export var priceLabel = "bR_gW";
export var priceValue = "bR_gX";
export var topSection = "bR_gT";
export var wrapper = "bR_bF";